import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'app/components';
import { convertCustomDateFormatToISO, convertISOToCustomDateFormat } from '../../../../utils/commonUtils';

const DateTime = (props) => {
  const { 
    setFormData, 
    formData, 
  } = props;

  const handleDateChange = (field) => (date) => {
    const dateObj = {};
    if (field === 'start_date' && date >= convertCustomDateFormatToISO(formData.end_date)) {
      dateObj.end_date = convertISOToCustomDateFormat(new Date(new Date(date).setHours(date.getHours() + 1, 0, 0, 0)).toUTCString());
    }
    const convertedStartDate = convertCustomDateFormatToISO(formData.start_date);
    if (field === 'end_date' && date <= convertedStartDate) {
      date = convertISOToCustomDateFormat(new Date(new Date(convertedStartDate).setHours(convertedStartDate?.getHours() + 1, 0, 0, 0)).toUTCString());
    } else date = convertISOToCustomDateFormat(date);
    
    setFormData({ 
      ...formData,
      ...dateObj,
      [field]: date, 
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="label-16 text-grey-70">Date</label>
      {/* Use a responsive grid: stacked on small screens, two columns on md+ */}
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2 self-stretch">
        <div className="w-full">
          <DatePicker
            disablePreviousDates
            selected={new Date(formData.start_date)}
            dateFormat="dd-MM-yyyy"
            label="Start date"
            onChange={handleDateChange('start_date')}
          />
        </div>
        <div className="w-full">
          <DatePicker
            type="time"
            label="Start time"
            dateFormat="h:mm aa"
            selected={new Date(formData.start_date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            onChange={handleDateChange('start_date')}
          />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2 self-stretch">
        <div className="w-full">
          <DatePicker
            disablePreviousDates={true}
            dateFormat="dd-MM-yyyy"
            minDate={new Date(formData.start_date)}
            selected={new Date(formData.end_date) < new Date(formData.start_date) ? new Date(formData.start_date) :new Date(formData.end_date)}
            label="End date"
            onChange={handleDateChange('end_date')}
          />
        </div>
        <div className="w-full">
          <DatePicker
            type="time"
            dateFormat="h:mm aa"
            label="End time"
            selected={new Date(formData.end_date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            onChange={handleDateChange('end_date')}
          />
        </div>
      </div>
    </div>
  )
}

DateTime.propTypes = {
  setFormData: PropTypes.func,
  formData: PropTypes.object,
};

DateTime.defaultProps = {
  setFormData: () => {},
  formData: {},
};

export default DateTime;
